import React from "react";

export default function OBAPageIntroComponent({ image, title, description }) {
  return (
    <section className="mb-5" data-aos="fade-right">
      <div
        className="rounded-3 border-vcg-muted p-5"
        style={{
          backgroundColor: "#fff",
        }}
      >
        <div className="row align-items-center">
          <div className="col-lg-8">
            <h2 className="fw-bold mb-3">{title}</h2>
            <p className="text-muted mb-0">{description}</p>
          </div>

          <div className="col-lg-4 text-center text-lg-end mt-4 mt-lg-0">
            <img
              src={image}
              alt="Vidyaloka Logo"
              className="img-fluid"
              style={{ maxWidth: "200px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
